import { connect } from "react-redux"
import {
    insightAreaSetEditMode,
    insightAreaItemSyncRequest
} from "../../../../actions/insight-area-actions"

import InsightAreaViewFormActionButtonsWidget from "./InsightAreaViewFormActionButtonsWidget"

const mapStateToProps = ({ presentation }) => ({
    canEdit: presentation.insightAreas.workingModel.can_edit,
    canDelete: false,
    showDelete: false,
    activeId: presentation.insightAreas.activeId,
    name: presentation.insightAreas.workingModel.name,
    canSync:
        presentation.insightAreas.workingModel.type &&
        ["Custom Map", "Customised"].indexOf(
            presentation.insightAreas.workingModel.type
        ) === -1,
    isFetching: presentation.insightAreas.isFetching,
})

const mapDispatchToProps = dispatch => ({
    onEdit: () => dispatch(insightAreaSetEditMode(true)),
    onTopicSync: id => dispatch(insightAreaItemSyncRequest())
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InsightAreaViewFormActionButtonsWidget)
